export const StatusServiceKeyword = 'status';

export const STATUS_BOARD_LNB_COLLAPSED_COOKIE = 'sb_lnb_collapsed';

export const SB_HOST_QUERY_KEY = {
  GET_LNB_COLLAPSED: 'GET_LNB_COLLAPSED',
} as const;

export const DEFAULT_LNB_COLLAPSED = false;
